import {
  Box,
  Card,
  CardContent,
  Chip,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";
import AIReviewedChip from "./AIReviewedChip";
import DataSourceIcon from "../../Components/DataSourcesPanel";

const RiskOverviewSection = ({
  overallScore,
  overallScoreValue,
  mappedRisks,
  onOpenRisk,
  entityId,
  AiSectionFeedback,

  // NEW (for backend feedback integration)
  requestId,
  uiSectionKey = "churn_risk_overview",
  userEmail,
}) => {
  return (
    <Card
      sx={{
        borderRadius: "0.9rem",
        border: "none",
        boxShadow: "0 12px 30px rgba(15,23,42,0.15)",
        bgcolor: "#ffffff",
        color: "#111827",
        mb: 3,
        mt: 4,
      }}
    >
      <CardContent sx={{ p: 3.5 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2.5,
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Tooltip
                  title="AI summary of key churn drivers scored from 1 (low) to 5 (high) for this relationship."
                  arrow
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      fontSize: "1.05rem",
                      color: "#003366",
                      cursor: "help",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    Churn Risk Overview
                  </Typography>
                </Tooltip>
                <AIReviewedChip mode="light" />
                <DataSourceIcon
                  mode="light"
                  sources={["Salesforce", "Nasdaq", "Web Search"]}
                />
              </Box>
            </Box>
          </Box>

          <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1.25 }}>
            {overallScore && (
              <Chip
                label={`Overall Risk Score: ${overallScoreValue} (${
                  overallScore.label || "Not Rated"
                })`}
                sx={{
                  bgcolor: "#E8F0FE",
                  color: "#003366",
                  fontWeight: 600,
                  fontSize: "0.8rem",
                  borderRadius: "999px",
                }}
              />
            )}

            <AiSectionFeedback
              sectionName="EntityProfile - Churn Risk Overview (AI-reviewed)"
              entityId={entityId}
              variant="light"
              requestId={requestId}
              uiSectionKey={uiSectionKey}
              userEmail={userEmail}
            />
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: 3, mb: 2, fontSize: "0.85rem" }}>
          <span>🟢 Low</span>
          <span>🟡 Medium</span>
          <span>🔴 High</span>
        </Box>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: 2,
          }}
        >
          {(mappedRisks || []).map((risk) => (
            <Box
              key={risk.id}
              sx={{
                borderRadius: "0.75rem",
                border: "1px solid #e5e7eb",
                p: 2,
                bgcolor: "#ffffff",
                display: "flex",
                flexDirection: "column",

                minHeight: 130,
                transition: "box-shadow 0.2s ease, transform 0.2s ease",
                "&:hover": {
                  boxShadow: "0 10px 24px rgba(15,23,42,0.12)",
                  transform: "translateY(-1px)",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  mb: 0,
                  gap: 0,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      bgcolor: risk.dotColor,
                    }}
                  />
                  <Typography
                    sx={{
                      fontWeight: 600,
                      color: "#003366",
                      fontSize: "0.9rem",
                    }}
                  >
                    {risk.title}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Chip
                    size="small"
                    label={risk.scoreLabel}
                    sx={{
                      fontSize: "0.75rem",
                      fontWeight: 600,
                      bgcolor: "#F3F4F6",
                      color: "#111827",
                      borderRadius: "999px",
                    }}
                  />

                  <Tooltip title="View details" arrow>
                    <IconButton
                      size="small"
                      onClick={() => onOpenRisk(risk)}
                      sx={{ color: "#003366", p: 0.25 }}
                    >
                      <InfoOutlineIcon fontSize="inherit" />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Box>

              <Typography
                sx={{ fontSize: "0.85rem", color: "#374151", mt: 1, ml: 2 }}
              >
                {risk.value}
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default RiskOverviewSection;
